<template>
  <div>
    <destination-marker ref="destinationMarker" />
    <spot-marker ref="spotMarker" />
    <google-place-marker />
    <location-marker />
    <my-spot-marker />
  </div>
</template>

<script>
import SpotMarker from './SpotMarker'
import DestinationMarker from './DestinationMarker'
import GooglePlaceMarker from './GooglePlaceMarker'
import LocationMarker from './LocationMarker'
import MySpotMarker from './MySpotMarker'

export default {
  components: {
    SpotMarker,
    DestinationMarker,
    GooglePlaceMarker,
    LocationMarker,
    MySpotMarker
  },
  methods: {
    onMarkerSelected: function (place) {
      this.$emit('markerSelected', place)
    },
    mapInitialized: function () {
      this.$refs.spotMarker.mapInitialized()
    },
    fitBoundsPlan: function () {
      this.$refs.destinationMarker.fitBoundsPlan()
    }
  }
}
</script>
